import React, { useState } from 'react';
import { useSearchParams } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import SubRegions from "./components/subRegions";
import Regions from "./components/regions";
import CommonLayout from "layouts/DashboardLayout";
import { getData } from 'utilities/common';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';

const HyperwolfRegions = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { tab } = Object.fromEntries(searchParams.entries()) || 'regions'
  const [activeTab, setActiveTab] = useState(tab || 'regions'); // 'regions' or 'subRegions'

  const handleTabChange = tab => {
    setActiveTab(tab);
    setSearchParams(`?tab=${tab}`)
  }
  let localUser = getData("login-user-info");
  if (localUser) {
    localUser = JSON.parse(localUser);
  }

  const adminMode = localStorage.getItem("adminsMode")
    ? JSON.parse(localStorage.getItem("adminsMode"))
    : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Inventory Distribution", "Create");
  const canView = hasSectionPermission(permissionsForMode, "Inventory Distribution", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Inventory Distribution", "Delete");
  const canEdit = hasSectionPermission(permissionsForMode, "Inventory Distribution", "Edit/Update");


  return (
    <CommonLayout>
      {
        canView && <>
          <Box pt={{ xs: 2, sm: 3, lg: 4 }} pl={{ xs: 2, sm: 3, lg: 4 }} pr={{ xs: 2, sm: 3, lg: 4 }} className="cannabinoids-tabs">
            <Stack direction='row' gap={1} sx={{ background: '#ffffff' }}>
              <Button
                variant='outlined'
                className={activeTab === 'regions' ? 'active' : ''}
                sx={{ color: '#2E2E3A' }}
                onClick={() => handleTabChange('regions')}
              >
                Regions
              </Button>
              <Button
                variant='outlined'
                className={activeTab === 'subRegions' ? 'active' : ''}
                sx={{ color: '#2E2E3A' }}
                onClick={() => handleTabChange('subRegions')}
              >
                Sub Regions
              </Button>
            </Stack>
          </Box>
          {activeTab === 'regions' ? <Regions canView={canView} canCreate={canCreate} canEdit={canEdit} canDelete={canDelete} /> : <SubRegions canView={canView} canCreate={canCreate} canEdit={canEdit} canDelete={canDelete} />}
        </>
      }
    </CommonLayout>
  );
};

export default HyperwolfRegions;

